import React from 'react'
import ProductAhan from '../../Products/ProductAhan'
import { Link } from 'react-router-dom'
import CategoryAhanPageORGEN from '../../Products/CategoryAhanPageORGEN'

function ProductCstegoryAhan() {
  return (
    <>
        <div className='c-Product' >
            <div className='c-titleProduct'>
                <div className='titleProduct'>
                    <h1> Iron Category </h1>
                    <p> The iron group includes metal products such as beams, rebars, angles and profiles, which are used in construction and various industries. These products are important due to their high strength and wide application in steel and industrial structures. </p>
                </div>
            </div>
            
            <div className='c-AllProduct'>
                    <div className='AllProduct-Ahan'>
                        {CategoryAhanPageORGEN.map((item) => {
                            return (
                                <Link to={`product?name=iron&id=${item.CategoryID}`}  key={item.ID}  onClick={() => window.scrollTo(0, 0)}>
                                    <div className="p-Product" key={item.ID}>
                                        <div className='c-img'> <img  src={item.ImageURL} alt="محصول 1" /> </div>
                                        <h4> {item.Name} </h4>
                                    </div>
                                </Link>
                            )
                        })}
                    </div>
            </div>
        </div>

    </>
  )
}

export default ProductCstegoryAhan
